import { useEffect, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import useResponsive from '../../../Hooks/useResponsive';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import { Box, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { getSkillxDashboard } from '../../../redux/features/skillxSlice';
import { useSelector } from 'react-redux';
import TopCountCards from './TopCountCards';

const SkillxDashboardLanding = () => {
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [direction, setDirection] = useState('row');
  const smDown = useResponsive('down', 'sm');
  const dispatch = useDispatch();
  const { loading, resData } = useSelector((store) => store.skillx);
  const { data } = resData;
  useEffect(() => {
    if (smDown) {
      setDirection('column');
    } else {
      setDirection('row');
    }
  }, [smDown]);

  useEffect(() => {
    dispatch(getSkillxDashboard({ fromDate, toDate }));
  }, [fromDate, toDate]);

  const UnconfirmedNavigation=()=>{
    console.log("clicked");
    
  }

  return (
    <GlobalWrapper title={'Skillx Dashboard'}>
      <Box>
        <Stack direction={direction} gap={1} mb={1}>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Stack>
      </Box>

      {!loading && (
        <TopCountCards
          assessmentTaken={data?.headData?.[0]?.totalAssessmentCount}
          reportGenerated={data?.headData?.[0]?.totalReportCount}
          totalCourseEnrollmentCount={data?.headData?.[0]?.totalCourseEnrollmentCount}
          totalAdmissionCount={data?.headData?.[0]?.totalAdmissionCount}
          totalArpu={data?.headData?.[0]?.totalArpu}
          totalAcr={data?.headData?.[0]?.totalAcr}
          totalTar={data?.headData?.[0]?.totalTar}
          totalSfr={data?.headData?.[0]?.totalSfr}
          top={data?.headData?.[0]?.topUserNames}
          saleAmount={data?.headData?.[0]?.totalTotalFees}
          revenue={data?.headData?.[0]?.totalRevenue}
          admissionNotConfirmed={data?.headData?.[0]?.totalUnenrolledCount}
          navigateFunction={UnconfirmedNavigation}
        />
      )}
    </GlobalWrapper>
  );
};

export default SkillxDashboardLanding;
